/* Showing a cached Blob in an <img> without leaking its object URL. */

/**
 * Point an `<img>` at a Blob via an object URL and revoke that URL as soon as the
 * image has loaded (or failed), so nothing leaks.
 *
 * Every image in the app comes from IndexedDB rather than the network — topic
 * thumbnails and the topic header both store their picture as a Blob — so this is
 * the one place that turns such a Blob into something an `<img>` can show.
 *
 * @param {?HTMLImageElement} img Target element; ignored when missing.
 * @param {?Blob} blob The cached image; ignored when it isn't a Blob.
 */
export function showBlobImage(img, blob) {
  if (!img || !(blob instanceof Blob)) return;
  const url = URL.createObjectURL(blob);
  img.src = url;
  const revoke = () => URL.revokeObjectURL(url);
  img.addEventListener('load', revoke, { once: true });
  img.addEventListener('error', revoke, { once: true });
}
